/**
 * 사전 안내 알림 수신 설정 API 파사드(specs/080) — 회원 본인 설정·메일 수신거부 링크.
 * 수신거부의 400(서명 불일치)은 화면이 안내 카드로 보여 주므로 무음.
 */
import { http, withErrors } from './http';

/** 알림 수신 설정(백엔드 NotificationPreferenceResponse). */
export interface NotificationPreference {
  enabled: boolean;
}

/** 알림 수신 설정 변경(백엔드 NotificationPreferenceRequest). */
export interface NotificationPreferenceRequest {
  enabled: boolean;
}

/** 수신거부 요청(백엔드 UnsubscribeRequest) — 메일 링크의 u·t 그대로. */
export interface UnsubscribeRequest {
  u: number;
  t: string;
}

export async function getNotificationPreference(): Promise<NotificationPreference> {
  const { data } = await http.get<NotificationPreference>('/fo/account/notification-preference');
  return data;
}

export async function changeNotificationPreference(
  enabled: boolean,
): Promise<NotificationPreference> {
  const { data } = await http.put<NotificationPreference>('/fo/account/notification-preference', {
    enabled,
  } satisfies NotificationPreferenceRequest);
  return data;
}

export async function unsubscribeNotification(request: UnsubscribeRequest): Promise<void> {
  await http.post(
    '/fo/public/notification/unsubscribe',
    request,
    withErrors({ silentStatuses: [400] }),
  );
}
